import React from 'react'
import { PLAN_TYPES, PlanTypes } from 'Types/PlansTypes'
import { BundlePricingPlanMobile } from 'Features/pricing/tabs/Bundles/Bundle.styled'
import { BundlePlanMobile } from 'Features/pricing/components/BundlePlanMobile/BundlePlanMobile'
import { ProductTypes } from 'Types/ProductTypes'
import { PlansJson } from 'Types/Plan'
import { Plan } from 'Features/pricing/types/Plan'
import { CurrenciesTypes } from 'Types/Currencies'

type BundlePlanMobileWrapperProps = {
  numOfVisits: number
  plansDb: Array<Plan>
  plansJson: PlansJson
  productName: ProductTypes
  currency: CurrenciesTypes
  selectedPlan: PlanTypes
  setSelectedPlan: (plan: PlanTypes) => void
}

export const BundlePlanMobileWrapper = ({
  numOfVisits,
  currency,
  productName,
  plansJson,
  plansDb,
  selectedPlan,
  setSelectedPlan,
}: BundlePlanMobileWrapperProps) => {
  const renderPlans = () => {
    return Object.entries(PLAN_TYPES).map(([key, value]) => {
      return (
        <BundlePricingPlanMobile key={key}>
          <BundlePlanMobile
            key={key}
            selectedPlan={selectedPlan}
            planName={value}
            plansJson={plansJson}
            plansDb={plansDb}
            numOfVisits={numOfVisits}
            currency={currency}
            setSelectedPlan={setSelectedPlan}
            productName={productName}
          />
        </BundlePricingPlanMobile>
      )
    })
  }

  return <BundlePricingPlanMobile>{renderPlans()}</BundlePricingPlanMobile>
}
